import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, NavLink, Redirect } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import Colors from './Colors';
import Icons from './Icons';
import Logos from './Logos';
import Backgrounds from './Backgrounds';
import Variables from './Variables';
import Maskings from './Maskings';
import Components from './Components';
// import NavigationIcons from './NavigationIcons';
import Contents from './Contents';
import Everify from './Everify';

function CMSContainer({ match }) {
  const permissions = getJson('permissions');
  
  return (
    <div className="module-inner">
      <div className="module-inner-title">CMS</div>
      <SideScrollingTab dragToScroll hideScrollButtons>
        <div className="generic-module-nav mb-3">
          {Acl(permissions, ['VIEW CMS COLORS']) && (
            <NavLink
              exact
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/colors"
            >
              Colors
            </NavLink>
          )}
          {Acl(permissions, ['VIEW CMS ICONS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/icons"
            >
              Icons
            </NavLink>
          )}
          {/* <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/cms/navigation_icons"
          >
            Navigation Icons
          </NavLink> */}
          {Acl(permissions, ['VIEW CMS LOGOS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/logos"
            >
              Logos
            </NavLink>
          )}
          {Acl(permissions, ['VIEW CMS BACKGROUNDS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/backgrounds"
            >
              Backgrounds
            </NavLink>
          )}
          {Acl(permissions, ['VIEW CMS VARIABLES']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/variables"
            >
              Variables
            </NavLink>
          )}
          {Acl(permissions, ['VIEW CMS MASKING']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/maskings"
            >
              Masking
            </NavLink>
          )}
          {Acl(permissions, ['VIEW CMS COMPONENTS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/components"
            >
              Components
            </NavLink>
          )}
          {Acl(permissions, ['VIEW CMS CONTENTS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/contents"
            >
              Contents
            </NavLink>
          )}
          {Acl(permissions, ['VIEW CMS COMPONENTS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/general-settings/cms/everify"
            >
              E-Verify
            </NavLink>
          )}
        </div>
      </SideScrollingTab>
      <Switch>
        {Acl(permissions, ['VIEW CMS COLORS']) && (
          <Route
            exact
            path="/general-settings/cms"
            render={() => <Redirect to="/general-settings/cms/colors" />}
          />
        )}
        {Acl(permissions, ['VIEW CMS COLORS']) && (
          <Route path={`${match.path}/colors`} component={Colors} />
        )}
        {Acl(permissions, ['VIEW CMS ICONS']) && (
          <Route path={`${match.path}/icons`} component={Icons} />
        )}
        {Acl(permissions, ['VIEW CMS LOGOS']) && (
          <Route path={`${match.path}/logos`} component={Logos} />
        )}
        {Acl(permissions, ['VIEW CMS BACKGROUNDS']) && (
          <Route path={`${match.path}/backgrounds`} component={Backgrounds} />
        )}
        {Acl(permissions, ['VIEW CMS VARIABLES']) && (
          <Route path={`${match.path}/variables`} component={Variables} />
        )}
        {Acl(permissions, ['VIEW CMS MASKING']) && (
          <Route path={`${match.path}/maskings`} component={Maskings} />
        )}
        {Acl(permissions, ['VIEW CMS COMPONENTS']) && (
          <Route path={`${match.path}/components`} component={Components} />
        )}
        {/* <Route path={`${match.path}/navigation_icons`} component={NavigationIcons} /> */}
        {Acl(permissions, ['VIEW CMS CONTENTS']) && (
          <Route path={`${match.path}/contents`} component={Contents} />
        )}
        {Acl(permissions, ['VIEW CMS COMPONENTS']) && (
          <Route path={`${match.path}/everify`} component={Everify} />
        )}
      </Switch>
    </div>
  );
}


CMSContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};


export default CMSContainer;
